import {
  DateFormats,
  formatDate,
  isSameTime,
  subtractTime,
  TimeUnit,
} from 'src/utils/time';

export const formatMessageDate = (date: string) => {
  if (isSameTime(date, new Date(), TimeUnit.day)) {
    return 'Today';
  }

  if (
    isSameTime(date, subtractTime(1, TimeUnit.days, new Date()), TimeUnit.day)
  ) {
    return 'Yesterday';
  }

  return formatDate(date, DateFormats.DD_MMM_YYYY).toUpperCase();
};
